export default (
    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.649 7.29577H13.281V0.263733H6.24899V1.89573H9.177L10.737 1.75172L10.761 1.82373L9.033 3.35973L0.968994 11.4238L2.121 12.5758L10.185 4.51173L11.721 2.78373L11.793 2.80773L11.649 4.36773V7.29577Z"
            fill="#1522B0"
        />
    </svg>
)
